module.exports = __webpack_public_path__ + "img/女士.e354a4b6.png";